import * as envs from './envs';

export interface IEnvConfig {
  name?: string;
  CONNECTORS: {
    ROOT: {
      baseUrl: string;
      apiToken: string;
    };
  };
}
let envConfig: IEnvConfig = undefined;
export function configEnv(): IEnvConfig {
  if (envConfig) {
    return envConfig;
  }
  const modeMap: Record<string, string> = { development: 'dev', production: 'prod' };
  const envName = import.meta.env.VITE_APP_ENV || modeMap[import.meta.env.MODE] || import.meta.env.MODE || 'dev';
  const currentConfig = envs[envName];
  return {
    ...currentConfig,
    name: envName,
  };
}
